const getters = {
  isSettingButtonVisible: state => {
    return state.isSettingButtonVisible
  },
  isAccountSettingButtonVisible: state => {
    return state.isAccountSettingButtonVisible
  },
  isIOSelectButtonVisible: state => {
    return state.isIOSelectButtonVisible
  },
  isAdvSelectButtonVisible: state => {
    return state.isAdvSelectButtonVisible
  },
  isNotificationButtonVisible: state => {
    return state.isNotificationButtonVisible
  },
}

export default getters
